module.exports = __webpack_public_path__ + "img/Marker.f121366e.svg";